<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'TwTabs',
  components: { FontAwesomeIcon },
  props: {
    tabs: {
      type: Array,
      default() {
        return []
      }
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    sizeClasses() {
      return {
        'px-3 py-3 text-xxs font-sans': this.size === 'sm',
        'px-3 py-3 text-xs font-sans': this.size === 'md',
        'px-4 py-2 text-sm font-sans': this.size === 'lg',
        'px-7 py-3 text-base font-sans': this.size === 'xl',
      }
    },
    sizeClassesBadge() {
      return {
        'px-2.5 ml-2 py-0.2 text-xxs font-sans': this.size === 'sm',
        'px-2.5 ml-2 py-0.5 text-xxs font-sans': this.size === 'md',
        'px-2.5 ml-2 py-0.5 text-xs font-sans': this.size === 'lg',
        'px-2.5 ml-2 py-0.5 text-sm font-sans': this.size === 'xl',
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="sm:hidden">
      <label for="tabs" class="sr-only">Select a tab</label>
      <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
      <select id="tabs" name="tabs" class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-600 focus:outline-none focus:ring-blue-500 ">
        <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">
          {{ tab.name }}
        </option>
      </select>
    </div>
    <div class="hidden sm:block">
      <nav class="flex flex-row gap-2" aria-label="Tabs">
        <component :is="tab.to? 'router-link':'a'" v-for="tab in tabs" :key="tab.name" :to="tab.to? tab.to:null" :class="[(tab.current || (tab.to && tab.to.name === $route.name)) ? 'text-gray-900 bg-gray-100 font-semibold' : '  hover:text-blue-600', 'rounded-md font-forms', sizeClasses]" :aria-current="tab.current ? 'page' : undefined">
          <font-awesome-icon v-if="tab.icon" :icon="tab.icon" />  {{ tab.name }}
          <span v-if="tab.count" :class="[(tab.current || (tab.to && tab.to.name === $route.name)) ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-900', 'hidden  rounded-full md:inline-block', sizeClassesBadge]">{{ tab.count }}</span>
        </component>
      </nav>
    </div>
  </div>
</template>

<style scoped>

</style>
